import React from 'react'
import PropTypes from 'prop-types'
import './NavCollapseButton.css'

export const NavCollapseButton = ({ onClick, active }) => (
  <button
    type="button"
    className="ss-nav-collapse-button"
    aria-label={active ? 'Close menu' : 'Open menu'}
    onClick={onClick}
  >
    <i
      className={
        active
          ? 'cursor-pointer fas fa-xmark ss-nav-collapse-icon ss-nav-collapse-icon-active'
          : 'cursor-pointer far fa-bars fa-lg ss-nav-collapse-icon'
      }
      aria-hidden="true"
    />
  </button>
)

NavCollapseButton.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/NavCollapseButton.js